{
    "AutocalcdurationLabel": "Bereken automatisch de duur bij het plannen van een rapport:",
    "BundleallemailattachinzipLabel": "Bundel alle e-mailbijlagen in een zipbestand:",
    "RunandcollatewithsimilarschedLabel": "Uitvoeren en sorteren met vergelijkbare periodieke rapportschema's:",
    "Advanced_SectionHeader": "Geavanceerd",
    "NAME": "Advanced"
}